import { createSlice } from '@reduxjs/toolkit'
import { AppLocales } from '../../appContants';

export const localeSlice = createSlice({
    name: 'locale',
    initialState: {
        value: AppLocales.enUs
    },
    reducers: {
        set: (state, action) => {
            state.value = action.payload;
        },
        unSet: state => {
            state.value = AppLocales.enUs;
        }
    }
})

// Action creators are generated for each case reducer function
export const { set, unSet } = localeSlice.actions

export default localeSlice.reducer